import { useState } from "react";
import { SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { Box } from "@chakra-ui/react";
import useGetCarteiras from "core/features/contas_bancarias/hooks/useGetCarteiras";

export interface SelectCarteiraProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any, item: any) => void;
  isInvalid?: boolean;
  bancoId: string;
}

function SelectCarteira({
  value,
  onChange,
  isInvalid,
  bancoId,
  ...rest
}: SelectCarteiraProps) {
  const [search, setSearch] = useState<string | undefined>();
  const { isFetching, data } = useGetCarteiras(bancoId);

  return (
    <SelectBaseAntd
      isInvalid={isInvalid}
      loading={isFetching}
      size="large"
      placeholder="Selecione a carteira"
      value={value || undefined}
      onChange={onChange}
      searchValue={search}
      onSearch={setSearch}
      showSearch
      allowClear
      optionFilterProp="label"
      options={data?.map((item) => ({
        value: item.id,
        label: item.nome,
      }))}
      {...rest}
      notFoundContent={<Box>Nenhuma carteira encontrada</Box>}
    />
  );
}

export default SelectCarteira;
